import { useContext } from "react";
import BulkSelectContext from "components/common/EntityDataTable/contexts/SelectEntitiesContext";
const useSelectedEntities = () => {
  const contextValue = useContext(BulkSelectContext);
  if (!contextValue) {
    throw new Error("useSelectedEntities hook needs to be used inside BulkSelectContext.Provider");
  }
  return contextValue;
};
export default useSelectedEntities;
